(function () {
  function init() {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll('[data-scroll-rotate]').forEach(function (el) {
      if (el.dataset.scrollRotateReady) return
      el.dataset.scrollRotateReady = 'true'

      const rotation = parseFloat(el.getAttribute('data-scroll-rotate'))
      if (isNaN(rotation)) return

      const section = el.closest('[data-section-id]') || el.parentElement

      gsap.from(el, {
        rotate: rotation,
        ease:  "power2.out",
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    })
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init()
  } else {
    window.addEventListener('load', init)
  }
})()
